// extracted by mini-css-extract-plugin
export var headerXL = "SectionCTA-module--headerXL--2ttd6";
export var headerL = "SectionCTA-module--headerL--2cyTj";
export var headerM = "SectionCTA-module--headerM--2hbMz";
export var headerS = "SectionCTA-module--headerS--Z47r3";
export var headerXS = "SectionCTA-module--headerXS--1dfn3";
export var blogHeaderXL = "SectionCTA-module--blogHeaderXL--3X14X";
export var blogHeaderL = "SectionCTA-module--blogHeaderL--33WAZ";
export var blogHeaderM = "SectionCTA-module--blogHeaderM--lFSJi";
export var blogHeaderS = "SectionCTA-module--blogHeaderS--1BKNK";
export var blogHeaderXS = "SectionCTA-module--blogHeaderXS--2Gh3h";
export var headerPreamble = "SectionCTA-module--headerPreamble--3ZUbf";
export var preHeader = "SectionCTA-module--preHeader--2cmgP";
export var textNormal = "SectionCTA-module--textNormal--3WYZ_";
export var textSmall = "SectionCTA-module--textSmall--1Zo8L";
export var textSmallAlternate = "SectionCTA-module--textSmallAlternate--quTHb";
export var legend = "SectionCTA-module--legend--3-_A7";
export var caption = "SectionCTA-module--caption--2Cruj";
export var gradientBackground = "SectionCTA-module--gradientBackground--37CMR";
export var ellipsis = "SectionCTA-module--ellipsis--83iV-";
export var globalContainer = "SectionCTA-module--globalContainer--21a7J";
export var maxWidth = "SectionCTA-module--maxWidth--2N3Am";
export var clipBottom = "SectionCTA-module--clipBottom--1rzLs";
export var clipTopBottom = "SectionCTA-module--clipTopBottom--77Qn6";
export var callToAction = "SectionCTA-module--callToAction--5yLAj";
export var ctaHeader = "SectionCTA-module--ctaHeader--3PfnE";
export var ctaButton = "SectionCTA-module--ctaButton--2F6UL";
export var floatingWhiteCubeImage = "SectionCTA-module--floatingWhiteCubeImage--22SfN";
export var laptopImage = "SectionCTA-module--laptopImage--1VQtm";
export var ch2 = "SectionCTA-module--ch2--3X9Yf";
export var ch2Container = "SectionCTA-module--ch2-container--275N0";